/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/products.
 *
 * `features` is a discriminated runtime shape: each element is either
 * a plain string (bullet-style, what ValuesIncubator uses) or a
 * `{ title, text }` object (card-style, what aiAdvisor and biteLearn
 * use). The renderer inspects the first element's typeof to choose a
 * layout — same call site in src/pages/ProductsPage.tsx as the static
 * `src/content/products.ts` used to drive.
 *
 * The flat `title` / `description` / `badge` / `features` / … fields
 * mirror the zh-Hant copy, so a consumer that does not care about
 * locales keeps working unchanged. A locale-aware consumer reads
 * `locales[locale]` instead — see src/content/cms/productLocale.ts.
 */

export interface CmsProductLocaleCopy {
  badge: string
  title: string
  description: string
  features: unknown[]
  audience: string
  table_features: string
  short_title: string
  image_alt: string
}

export interface CmsProductIndexEntry {
  id: number
  slug: string
  category: 'system' | 'service' | 'tool'
  accent_gradient: string
  icon: string
  cta_link: string
  badge: string
  title: string
  description: string
  features: unknown[]
  audience: string
  table_features: string
  short_title: string
  image_media_id: number | null
  image_uuid: string | null
  image_alt: string
  image_width: number | null
  image_height: number | null
  is_featured: number
  sort_order: number
  published_at: number | null
  /** Every locale's copy, resolved at build time. */
  locales: {
    'zh-Hant': CmsProductLocaleCopy
    'zh-Hans': CmsProductLocaleCopy
    en: CmsProductLocaleCopy
  }
}

export const cmsProducts: CmsProductIndexEntry[] = [
  {
    "id": 13,
    "slug": "csp",
    "category": "system",
    "accent_gradient": "from-yada-green to-yada-green-dark",
    "icon": "lucide:rocket",
    "cta_link": "https://csp.yada.hk/",
    "badge": "新產品",
    "title": "CSP — 升學及職涯起航平台",
    "description": "學校品牌平台 · 最快一星期上線 · 無需編碼",
    "features": [
      {
        "title": "升學樞紐 · FuturePath · 精選故事",
        "text": "JUPAS、UGC、海外升學一站導航，配合行業心智圖與真實故事，啟發學生探索自己的職涯方向。"
      },
      {
        "title": "模擬面試 · 履歷診所 · 師友計劃",
        "text": "職涯詞典、模擬面試、履歷診所、師友計劃、問卷、活動報名與獎學金指南，一次過裝備學生迎接職場過渡。"
      },
      {
        "title": "即開即用學校品牌平台",
        "text": "主題、選單、WYSIWYG、logo 與自訂網域一次到位，最快一星期部署，無需編碼。"
      },
      {
        "title": "可選 SmartCindy 升學顧問",
        "text": "可選的升學顧問小工具：即時解答 JUPAS 分數、課程及海外升學資訊。"
      },
      {
        "title": "頭 50 間學校特別優惠",
        "text": "限時優惠名額，報名即享；立即聯絡鎖定優惠。"
      }
    ],
    "audience": "中小學",
    "table_features": "升學樞紐、FuturePath、精選故事、學校品牌平台、限時優惠",
    "short_title": "CSP 升學職涯",
    "image_media_id": 59,
    "image_uuid": "ff733b3c-c8bc-4f9b-818e-991ebfe37adb",
    "image_alt": "CSP 升學及職涯起航平台主視覺：香港學生在生涯規劃輔導中與老師商討升學方向",
    "image_width": 1280,
    "image_height": 720,
    "is_featured": 0,
    "sort_order": 5,
    "published_at": 1793836819121,
    "locales": {
      "zh-Hant": {
        "badge": "新產品",
        "title": "CSP — 升學及職涯起航平台",
        "description": "學校品牌平台 · 最快一星期上線 · 無需編碼",
        "features": [
          {
            "title": "升學樞紐 · FuturePath · 精選故事",
            "text": "JUPAS、UGC、海外升學一站導航，配合行業心智圖與真實故事，啟發學生探索自己的職涯方向。"
          },
          {
            "title": "模擬面試 · 履歷診所 · 師友計劃",
            "text": "職涯詞典、模擬面試、履歷診所、師友計劃、問卷、活動報名與獎學金指南，一次過裝備學生迎接職場過渡。"
          },
          {
            "title": "即開即用學校品牌平台",
            "text": "主題、選單、WYSIWYG、logo 與自訂網域一次到位，最快一星期部署，無需編碼。"
          },
          {
            "title": "可選 SmartCindy 升學顧問",
            "text": "可選的升學顧問小工具：即時解答 JUPAS 分數、課程及海外升學資訊。"
          },
          {
            "title": "頭 50 間學校特別優惠",
            "text": "限時優惠名額，報名即享；立即聯絡鎖定優惠。"
          }
        ],
        "audience": "中小學",
        "table_features": "升學樞紐、FuturePath、精選故事、學校品牌平台、限時優惠",
        "short_title": "CSP 升學職涯",
        "image_alt": "CSP 升學及職涯起航平台主視覺：香港學生在生涯規劃輔導中與老師商討升學方向"
      },
      "zh-Hans": {
        "badge": "新产品",
        "title": "CSP — 升学及职涯起航平台",
        "description": "学校品牌平台 · 最快一星期上线 · 无需编码",
        "features": [
          {
            "title": "升学枢纽 · FuturePath · 精选故事",
            "text": "JUPAS、UGC、海外升学一站导航，配合行业心智图与真实故事，启发学生探索自己的职涯方向。"
          },
          {
            "title": "模拟面试 · 履历诊所 · 师友计划",
            "text": "职涯词典、模拟面试、履历诊所、师友计划、问卷、活动报名与奖学金指南，一次过装备学生迎接职场过渡。"
          },
          {
            "title": "即开即用学校品牌平台",
            "text": "主题、选单、WYSIWYG、logo 与自订域名一次到位，最快一星期部署，无需编码。"
          },
          {
            "title": "可选 SmartCindy 升学顾问",
            "text": "可选的升学顾问小工具：即时解答 JUPAS 分数、课程及海外升学信息。"
          },
          {
            "title": "头 50 间学校特别优惠",
            "text": "限时优惠名额，报名即享；立即联络锁定优惠。"
          }
        ],
        "audience": "中小学",
        "table_features": "升学枢纽、FuturePath、精选故事、学校品牌平台、限时优惠",
        "short_title": "CSP 升学职涯",
        "image_alt": "CSP 升学及职涯起航平台主视觉：香港学生在生涯规划辅导中与老师商讨升学方向"
      },
      "en": {
        "badge": "New",
        "title": "CSP — Career & Study Launchpad",
        "description": "School-branded platform · Live in as little as a week · No coding required",
        "features": [
          {
            "title": "Studies Hub · FuturePath · Featured Stories",
            "text": "One-stop navigation across JUPAS, UGC and overseas pathways, with industry mind maps and real stories that spark students’ own career direction."
          },
          {
            "title": "Mock Interviews · CV Clinic · Mentoring",
            "text": "Career dictionary, mock interviews, CV clinic, mentoring, surveys, event sign-ups and scholarship guides — everything students need to make the move into work."
          },
          {
            "title": "Ready-to-use branded school platform",
            "text": "Theme, menus, WYSIWYG editing, logo and custom domain set up in one go — deployed in as little as a week, with no coding."
          },
          {
            "title": "Optional SmartCindy study advisor",
            "text": "An optional study-advisor widget with instant answers on JUPAS scores, programmes and overseas pathways."
          },
          {
            "title": "Special offer for the first 50 schools",
            "text": "Limited places on the offer — sign up to enjoy it, and contact us now to lock it in."
          }
        ],
        "audience": "Primary & secondary schools",
        "table_features": "Studies Hub, FuturePath, Featured Stories, School branding, Limited-time offer",
        "short_title": "CSP Career & Study",
        "image_alt": "CSP Career & Study Launchpad: Hong Kong students discussing study and career plans with a teacher in a career guidance session"
      }
    }
  },
  {
    "id": 1,
    "slug": "values-incubator",
    "category": "system",
    "accent_gradient": "from-primary to-primary-dark",
    "icon": "lucide:sparkles",
    "cta_link": "/products/values-incubator",
    "badge": "旗艦方案",
    "title": "ValuesIncubator+ — 品格教育數碼系統",
    "description": "讓每一次肯定，都成為孩子心裡的一顆種子。",
    "features": [
      "即時優點卡 M‑Card — 掃碼解鎖・即時肯定",
      "多維度評量 — 自評＋師評＋家長評，360 度看見成長",
      "AI 成長報告 — 個人化敘事，升學就業好幫手",
      "家長守護者專區 — 專屬連結・家校同步不中斷",
      "正向成長故事 — 漫畫卡漫讀故事・潛移默化好品格",
      "教師管理後台 — 專屬卡袋・價值設定・輕鬆配對教育局"
    ],
    "audience": "中小學",
    "table_features": "品格教育、優點卡、AI 報告、家校同步",
    "short_title": "ValuesIncubator+",
    "image_media_id": 28,
    "image_uuid": "cd96c6bf-8446-408a-a085-e330a2659f1b",
    "image_alt": "價值觀教育 Priority Values 海報：12 款核心價值卡（國家身份認同、責任感、尊重他人、堅毅、守法、仁愛、誠信、承擔精神、孝親、團結、勤勞、同理心），中英對照",
    "image_width": 2800,
    "image_height": 2800,
    "is_featured": 1,
    "sort_order": 10,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "badge": "旗艦方案",
        "title": "ValuesIncubator+ — 品格教育數碼系統",
        "description": "讓每一次肯定，都成為孩子心裡的一顆種子。",
        "features": [
          "即時優點卡 M‑Card — 掃碼解鎖・即時肯定",
          "多維度評量 — 自評＋師評＋家長評，360 度看見成長",
          "AI 成長報告 — 個人化敘事，升學就業好幫手",
          "家長守護者專區 — 專屬連結・家校同步不中斷",
          "正向成長故事 — 漫畫卡漫讀故事・潛移默化好品格",
          "教師管理後台 — 專屬卡袋・價值設定・輕鬆配對教育局"
        ],
        "audience": "中小學",
        "table_features": "品格教育、優點卡、AI 報告、家校同步",
        "short_title": "ValuesIncubator+",
        "image_alt": "價值觀教育 Priority Values 海報：12 款核心價值卡（國家身份認同、責任感、尊重他人、堅毅、守法、仁愛、誠信、承擔精神、孝親、團結、勤勞、同理心），中英對照"
      },
      "zh-Hans": {
        "badge": "旗舰方案",
        "title": "ValuesIncubator+ — 品格教育数码系统",
        "description": "让每一次肯定，都成为孩子心里的一颗种子。",
        "features": [
          "即时优点卡 M‑Card — 扫码解锁・即时肯定",
          "多维度评量 — 自评＋师评＋家长评，360 度看见成长",
          "AI 成长报告 — 个人化叙事，升学就业好帮手",
          "家长守护者专区 — 专属连结・家校同步不中断",
          "正向成长故事 — 漫画卡漫读故事・潜移默化好品格",
          "教师管理后台 — 专属卡袋・价值设定・轻松配对教育局"
        ],
        "audience": "中小学",
        "table_features": "品格教育、优点卡、AI 报告、家校同步",
        "short_title": "ValuesIncubator+",
        "image_alt": "价值观教育 Priority Values 海报：12 款核心价值卡（国家身份认同、责任感、尊重他人、坚毅、守法、仁爱、诚信、承担精神、孝亲、团结、勤劳、同理心），中英对照"
      },
      "en": {
        "badge": "Flagship",
        "title": "ValuesIncubator+ — Character Education Digital System",
        "description": "Every affirmation becomes a seed in a child's heart.",
        "features": [
          "Instant M‑Card — scan to unlock, immediate affirmation",
          "Multi-dimensional assessment — self + teacher + parent, 360° growth view",
          "AI growth reports — personalised narratives for further-study and careers",
          "Parent guardian zone — dedicated link keeps home–school in sync",
          "Positive growth stories — illustrated cards nurture good character",
          "Teacher admin console — custom card packs and value settings for EDB alignment"
        ],
        "audience": "Primary & Secondary",
        "table_features": "Character education, merit cards, AI reports, home-school sync",
        "short_title": "ValuesIncubator+",
        "image_alt": "Priority Values poster: 12 core value cards (national identity, responsibility, respect for others, perseverance, law-abidingness, benevolence, integrity, commitment, filial piety, unity, diligence, empathy), bilingual"
      }
    }
  },
  {
    "id": 12,
    "slug": "national-education",
    "category": "system",
    "accent_gradient": "from-yada-green to-yada-green-dark",
    "icon": "lucide:landmark",
    "cta_link": "mailto:info@yada.hk",
    "badge": "",
    "title": "國民教育數碼系統",
    "description": "四大核心支柱，一站式融入校園日常",
    "features": [
      {
        "title": "依指引度身設計",
        "text": "對應教育局國民教育指引的課程框架與學習目標，無需從零建立"
      },
      {
        "title": "四大核心支柱",
        "text": "憲制秩序、安全與法治；國家歷史與文化認同；現代發展與戰略定位；全球視野與國際責任"
      },
      {
        "title": "課程規劃與檢視",
        "text": "學期規劃、課節編排、推行紀錄與檢視報告在同一系統完成"
      },
      {
        "title": "融入校園日常",
        "text": "結合活動、講座與學生任務，讓國民教育自然融入既有校本課程"
      },
      {
        "title": "多語支援",
        "text": "中英雙語內容，貼合學校現行教學語言"
      },
      {
        "title": "成效數據",
        "text": "參與人次、活動覆蓋與學習成果一目了然，隨時向校方匯報"
      }
    ],
    "audience": "中小學",
    "table_features": "四大支柱、課程管理、學生活動、成效檢視",
    "short_title": "國民教育",
    "image_media_id": 53,
    "image_uuid": "fbf3b412-5ac1-4282-bf22-0959d8583583",
    "image_alt": "國民教育數碼系統：四大核心支柱，一站式融入校園日常",
    "image_width": 1280,
    "image_height": 720,
    "is_featured": 1,
    "sort_order": 15,
    "published_at": 1792202025196,
    "locales": {
      "zh-Hant": {
        "badge": "",
        "title": "國民教育數碼系統",
        "description": "四大核心支柱，一站式融入校園日常",
        "features": [
          {
            "title": "依指引度身設計",
            "text": "對應教育局國民教育指引的課程框架與學習目標，無需從零建立"
          },
          {
            "title": "四大核心支柱",
            "text": "憲制秩序、安全與法治；國家歷史與文化認同；現代發展與戰略定位；全球視野與國際責任"
          },
          {
            "title": "課程規劃與檢視",
            "text": "學期規劃、課節編排、推行紀錄與檢視報告在同一系統完成"
          },
          {
            "title": "融入校園日常",
            "text": "結合活動、講座與學生任務，讓國民教育自然融入既有校本課程"
          },
          {
            "title": "多語支援",
            "text": "中英雙語內容，貼合學校現行教學語言"
          },
          {
            "title": "成效數據",
            "text": "參與人次、活動覆蓋與學習成果一目了然，隨時向校方匯報"
          }
        ],
        "audience": "中小學",
        "table_features": "四大支柱、課程管理、學生活動、成效檢視",
        "short_title": "國民教育",
        "image_alt": "國民教育數碼系統：四大核心支柱，一站式融入校園日常"
      },
      "zh-Hans": {
        "badge": "",
        "title": "国民教育数码系统",
        "description": "四大核心支柱，一站式融入校园日常",
        "features": [
          {
            "title": "依指引度身设计",
            "text": "对应教育局国民教育指引的课程框架与学习目标，无需从零建立"
          },
          {
            "title": "四大核心支柱",
            "text": "宪制秩序、安全与法治；国家历史与文化认同；现代发展与战略定位；全球视野与国际责任"
          },
          {
            "title": "课程规划与检视",
            "text": "学期规划、课节编排、推行纪录与检视报告在同一系统完成"
          },
          {
            "title": "融入校园日常",
            "text": "结合活动、讲座与学生任务，让国民教育自然融入既有校本课程"
          },
          {
            "title": "多语支援",
            "text": "中英双语内容，贴合学校现行教学语言"
          },
          {
            "title": "成效数据",
            "text": "参与人次、活动覆盖与学习成果一目了然，随时向校方汇报"
          }
        ],
        "audience": "中小学",
        "table_features": "四大支柱、课程管理、学生活动、成效检视",
        "short_title": "国民教育",
        "image_alt": "国民教育数码系统：四大核心支柱，一站式融入校园日常"
      },
      "en": {
        "badge": "",
        "title": "National Education Digital System",
        "description": "Four core strands, seamlessly woven into school life",
        "features": [
          {
            "title": "Built to the guidelines",
            "text": "Maps directly to the Education Bureau's curriculum framework and learning outcomes — no need to build from scratch"
          },
          {
            "title": "Four core strands",
            "text": "Constitutional order, security and rule of law; national history and cultural identity; modern development and strategic positioning; a global outlook"
          },
          {
            "title": "Planning and review",
            "text": "Term planning, lesson scheduling, delivery records and review reports all in one system"
          },
          {
            "title": "Woven into school life",
            "text": "Activities, talks and student tasks blend national education into the curriculum you already run"
          },
          {
            "title": "Bilingual",
            "text": "Chinese and English content, matching your school's language of instruction"
          },
          {
            "title": "Outcome data",
            "text": "Participation, coverage and learning outcomes visible at a glance, ready to report to the school"
          }
        ],
        "audience": "Primary & secondary schools",
        "table_features": "Four strands, curriculum planning, student activities, review",
        "short_title": "National Education",
        "image_alt": "National Education Digital System: four core pillars integrated into everyday school life"
      }
    }
  },
  {
    "id": 2,
    "slug": "ai-advisor",
    "category": "system",
    "accent_gradient": "from-yada-green to-yada-green-dark",
    "icon": "lucide:bot",
    "cta_link": "/products/smart-cindy",
    "badge": "新產品",
    "title": "SmartCindy — AI 升學及就業顧問",
    "description": "專為香港 DSE 學生而設的 AI 升學及就業顧問，24 小時在 WhatsApp 即問即答，答案來自經過整理與驗證的校本知識庫。",
    "features": [
      {
        "title": "全校專屬・數據隔離",
        "text": "獨立儲存，不用於訓練公共 AI"
      },
      {
        "title": "專屬 RAG 伺服器",
        "text": "檢索校本資料（升學手冊、校友分享、講座簡報）"
      },
      {
        "title": "涵蓋全部升學就業途徑",
        "text": "JUPAS、大學比較、職業配對、IVE／HKDI、海外升學、內地升學"
      },
      {
        "title": "WhatsApp 進駐",
        "text": "無需下載 App・零學習成本"
      },
      {
        "title": "對話警示系統",
        "text": "自動標記需輔導個案"
      },
      {
        "title": "學校儀表板",
        "text": "掌握熱門問題及學生關注趨勢"
      }
    ],
    "audience": "中學（中四至中六）",
    "table_features": "WhatsApp AI 問答、校本 RAG、24/7 升學就業顧問",
    "short_title": "SmartCindy",
    "image_media_id": 50,
    "image_uuid": "8d2d859c-8b8d-4b63-902b-965b9032e4a6",
    "image_alt": "SmartCindy AI 升學及就業顧問：戴上耳機的學生微笑作答，背景是香港城市天際線與 AI 網絡圖示",
    "image_width": 2048,
    "image_height": 1152,
    "is_featured": 0,
    "sort_order": 20,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "badge": "新產品",
        "title": "SmartCindy — AI 升學及就業顧問",
        "description": "專為香港 DSE 學生而設的 AI 升學及就業顧問，24 小時在 WhatsApp 即問即答，答案來自經過整理與驗證的校本知識庫。",
        "features": [
          {
            "title": "全校專屬・數據隔離",
            "text": "獨立儲存，不用於訓練公共 AI"
          },
          {
            "title": "專屬 RAG 伺服器",
            "text": "檢索校本資料（升學手冊、校友分享、講座簡報）"
          },
          {
            "title": "涵蓋全部升學就業途徑",
            "text": "JUPAS、大學比較、職業配對、IVE／HKDI、海外升學、內地升學"
          },
          {
            "title": "WhatsApp 進駐",
            "text": "無需下載 App・零學習成本"
          },
          {
            "title": "對話警示系統",
            "text": "自動標記需輔導個案"
          },
          {
            "title": "學校儀表板",
            "text": "掌握熱門問題及學生關注趨勢"
          }
        ],
        "audience": "中學（中四至中六）",
        "table_features": "WhatsApp AI 問答、校本 RAG、24/7 升學就業顧問",
        "short_title": "SmartCindy",
        "image_alt": "SmartCindy AI 升學及就業顧問：戴上耳機的學生微笑作答，背景是香港城市天際線與 AI 網絡圖示"
      },
      "zh-Hans": {
        "badge": "新产品",
        "title": "SmartCindy — AI 升学及就业顾问",
        "description": "专为香港 DSE 学生而设的 AI 升学及就业顾问，24 小时在 WhatsApp 即问即答，答案来自经过整理与验证的校本知识库。",
        "features": [
          {
            "title": "全校专属・数据隔离",
            "text": "独立储存，不用于训练公共 AI"
          },
          {
            "title": "专属 RAG 服务器",
            "text": "检索校本资料（升学手册、校友分享、讲座简报）"
          },
          {
            "title": "涵盖全部升学就业途径",
            "text": "JUPAS、大学比较、职业配对、IVE／HKDI、海外升学、内地升学"
          },
          {
            "title": "WhatsApp 进驻",
            "text": "无需下载 App・零学习成本"
          },
          {
            "title": "对话警示系统",
            "text": "自动标记需辅导个案"
          },
          {
            "title": "学校仪表板",
            "text": "掌握热门问题及学生关注趋势"
          }
        ],
        "audience": "中学（中四至中六）",
        "table_features": "WhatsApp AI 问答、校本 RAG、24/7 升学就业顾问",
        "short_title": "SmartCindy",
        "image_alt": "SmartCindy AI 升学及就业顾问：戴着耳机的学生微笑作答，背景是香港城市天际线与 AI 网络图标"
      },
      "en": {
        "badge": "New",
        "title": "SmartCindy — AI Study & Career Advisor",
        "description": "A 24/7 AI study and career advisor for Hong Kong DSE students — ask on WhatsApp, get answers grounded in your school’s verified knowledge base.",
        "features": [
          {
            "title": "School-exclusive · Data Isolated",
            "text": "Stored independently, never used to train public AI"
          },
          {
            "title": "Dedicated RAG Server",
            "text": "Retrieves school-specific materials (study guides, alumni talks, lecture notes)"
          },
          {
            "title": "Full Pathway Coverage",
            "text": "JUPAS, university comparison, career matching, IVE/HKDI, overseas, and mainland study"
          },
          {
            "title": "WhatsApp-native",
            "text": "No app to install — zero learning curve"
          },
          {
            "title": "Conversation Alert System",
            "text": "Automatically flags students who need follow-up"
          },
          {
            "title": "School Dashboard",
            "text": "Track hot questions and student interests"
          }
        ],
        "audience": "Secondary (S4–S6)",
        "table_features": "WhatsApp AI Q&A, school RAG, 24/7 study & career advice",
        "short_title": "SmartCindy",
        "image_alt": "SmartCindy, the AI further-study and career advisor: a student wearing a headset smiling, with the Hong Kong skyline and an AI network diagram behind"
      }
    }
  },
  {
    "id": 3,
    "slug": "bite-learn",
    "category": "system",
    "accent_gradient": "from-yada-green to-yada-green-dark",
    "icon": "lucide:graduation-cap",
    "cta_link": "mailto:info@yada.hk",
    "badge": "",
    "title": "BiteLearn — AI 微學習自動派發系統",
    "description": "將課堂規模的單元轉化為每日小塊化微課堂，系統自動生成並直接發送至學生的 WhatsApp。",
    "features": [
      {
        "title": "AI 自動生成",
        "text": "4 種生成模式：純 AI／手動／混合／AI 備援，自動配題・難度平衡"
      },
      {
        "title": "WhatsApp 自動派發",
        "text": "定時自動廣播，支援多班別同時發送，支援圖片、公式、圖表"
      },
      {
        "title": "遊戲化學習",
        "text": "每日挑戰・排行榜即時反映，鞏固新知識・良性競爭"
      },
      {
        "title": "課程管理",
        "text": "完整樹狀結構：科目 → 課題 → 子題 → 學習目標"
      },
      {
        "title": "題庫管理",
        "text": "AI 自動生成 MC 題，支援 PDF、CSV、ZIP 批量匯入"
      },
      {
        "title": "數據儀表板",
        "text": "即時統計發送數量、課程進度、月曆排程"
      }
    ],
    "audience": "中小學",
    "table_features": "AI 微學習派發、遊戲化、儀表板",
    "short_title": "BiteLearn",
    "image_media_id": 15,
    "image_uuid": "3ddc1e85-8bfd-4049-9df7-f060f1c9eff7",
    "image_alt": "每日推送微學習課程：課堂單元、自動生成、推送至手機、閒置時間學習",
    "image_width": 1400,
    "image_height": 711,
    "is_featured": 1,
    "sort_order": 30,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "badge": "",
        "title": "BiteLearn — AI 微學習自動派發系統",
        "description": "將課堂規模的單元轉化為每日小塊化微課堂，系統自動生成並直接發送至學生的 WhatsApp。",
        "features": [
          {
            "title": "AI 自動生成",
            "text": "4 種生成模式：純 AI／手動／混合／AI 備援，自動配題・難度平衡"
          },
          {
            "title": "WhatsApp 自動派發",
            "text": "定時自動廣播，支援多班別同時發送，支援圖片、公式、圖表"
          },
          {
            "title": "遊戲化學習",
            "text": "每日挑戰・排行榜即時反映，鞏固新知識・良性競爭"
          },
          {
            "title": "課程管理",
            "text": "完整樹狀結構：科目 → 課題 → 子題 → 學習目標"
          },
          {
            "title": "題庫管理",
            "text": "AI 自動生成 MC 題，支援 PDF、CSV、ZIP 批量匯入"
          },
          {
            "title": "數據儀表板",
            "text": "即時統計發送數量、課程進度、月曆排程"
          }
        ],
        "audience": "中小學",
        "table_features": "AI 微學習派發、遊戲化、儀表板",
        "short_title": "BiteLearn",
        "image_alt": "每日推送微學習課程：課堂單元、自動生成、推送至手機、閒置時間學習"
      },
      "zh-Hans": {
        "badge": "",
        "title": "BiteLearn — AI 微学习自动派发系统",
        "description": "将课堂规模的单元转化为每日小块化微课堂，系统自动生成并直接发送至学生的 WhatsApp。",
        "features": [
          {
            "title": "AI 自动生成",
            "text": "4 种生成模式：纯 AI／手动／混合／AI 备援，自动配题・难度平衡"
          },
          {
            "title": "WhatsApp 自动派发",
            "text": "定时自动广播，支援多班别同时发送，支援图片、公式、图表"
          },
          {
            "title": "游戏化学习",
            "text": "每日挑战・排行榜即时反映，巩固新知识・良性竞争"
          },
          {
            "title": "课程管理",
            "text": "完整树状结构：科目 → 课题 → 子题 → 学习目标"
          },
          {
            "title": "题库管理",
            "text": "AI 自动生成 MC 题，支援 PDF、CSV、ZIP 批量汇入"
          },
          {
            "title": "数据仪表板",
            "text": "即时统计发送数量、课程进度、月历排程"
          }
        ],
        "audience": "中小学",
        "table_features": "AI 微学习派发、游戏化、仪表板",
        "short_title": "BiteLearn",
        "image_alt": "每日推送微学习课程：课堂单元、自动生成、推送至手机、闲置时间学习"
      },
      "en": {
        "badge": "",
        "title": "BiteLearn — AI Micro-Learning Auto-Dispatch",
        "description": "Classroom-sized units become a small daily micro-lesson. The system generates it and sends it straight to the student's WhatsApp.",
        "features": [
          {
            "title": "AI Generation",
            "text": "4 modes: pure AI / manual / hybrid / AI backup; auto difficulty balancing"
          },
          {
            "title": "WhatsApp Push",
            "text": "Scheduled broadcast to multiple classes; images, formulas, charts supported"
          },
          {
            "title": "Gamified Learning",
            "text": "Daily challenges, live leaderboards, friendly competition"
          },
          {
            "title": "Curriculum Management",
            "text": "Full tree: Subject → Topic → Sub-topic → Learning objective"
          },
          {
            "title": "Question Bank",
            "text": "AI-generated MC questions; bulk import from PDF, CSV, ZIP"
          },
          {
            "title": "Data Dashboard",
            "text": "Real-time stats: deliveries, curriculum progress, monthly schedule"
          }
        ],
        "audience": "Primary & Secondary",
        "table_features": "AI micro-learning dispatch, gamification, dashboards",
        "short_title": "BiteLearn",
        "image_alt": "Daily micro-lessons: classroom units, automatic generation, phone delivery, learning in idle time"
      }
    }
  },
  {
    "id": 4,
    "slug": "hackathon",
    "category": "service",
    "accent_gradient": "from-yada-gold to-yada-olive",
    "icon": "lucide:trophy",
    "cta_link": "mailto:info@yada.hk",
    "badge": "",
    "title": "生涯與升學 Hackathon",
    "description": "以創新競賽形式激發青年探索升學及職業方向。",
    "features": [],
    "audience": "",
    "table_features": "",
    "short_title": "生涯與升學 Hackathon",
    "image_media_id": null,
    "image_uuid": null,
    "image_alt": "",
    "image_width": null,
    "image_height": null,
    "is_featured": 0,
    "sort_order": 40,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "badge": "",
        "title": "生涯與升學 Hackathon",
        "description": "以創新競賽形式激發青年探索升學及職業方向。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "生涯與升學 Hackathon",
        "image_alt": ""
      },
      "zh-Hans": {
        "badge": "",
        "title": "生涯与升学 Hackathon",
        "description": "以创新竞赛形式激发青年探索升学及职业方向。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "生涯与升学 Hackathon",
        "image_alt": ""
      },
      "en": {
        "badge": "",
        "title": "Career & Further-Study Hackathon",
        "description": "An innovation competition that sparks young people's exploration of further-study and career directions.",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "Career & Further-Study Hackathon",
        "image_alt": ""
      }
    }
  },
  {
    "id": 5,
    "slug": "exploration-trip",
    "category": "service",
    "accent_gradient": "from-yada-green to-yada-green-dark",
    "icon": "lucide:map",
    "cta_link": "mailto:info@yada.hk",
    "badge": "",
    "title": "探索之旅",
    "description": "帶領學生實地參觀香港及大灣區企業，親身體驗職場實況。",
    "features": [],
    "audience": "",
    "table_features": "",
    "short_title": "探索之旅",
    "image_media_id": null,
    "image_uuid": null,
    "image_alt": "",
    "image_width": null,
    "image_height": null,
    "is_featured": 0,
    "sort_order": 50,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "badge": "",
        "title": "探索之旅",
        "description": "帶領學生實地參觀香港及大灣區企業，親身體驗職場實況。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "探索之旅",
        "image_alt": ""
      },
      "zh-Hans": {
        "badge": "",
        "title": "探索之旅",
        "description": "带领学生实地参观香港及大湾区企业，亲身体验职场实况。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "探索之旅",
        "image_alt": ""
      },
      "en": {
        "badge": "",
        "title": "Exploration Trips",
        "description": "Guided visits to companies in Hong Kong and the Greater Bay Area for first-hand workplace experience.",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "Exploration Trips",
        "image_alt": ""
      }
    }
  },
  {
    "id": 6,
    "slug": "mentorship",
    "category": "service",
    "accent_gradient": "from-yada-olive to-yada-brown",
    "icon": "lucide:users",
    "cta_link": "mailto:info@yada.hk",
    "badge": "",
    "title": "師友及教練服務",
    "description": "以科技及實體提供一對一或小組形式的 mentorship 及 coaching。",
    "features": [],
    "audience": "",
    "table_features": "",
    "short_title": "師友及教練服務",
    "image_media_id": null,
    "image_uuid": null,
    "image_alt": "",
    "image_width": null,
    "image_height": null,
    "is_featured": 0,
    "sort_order": 60,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "badge": "",
        "title": "師友及教練服務",
        "description": "以科技及實體提供一對一或小組形式的 mentorship 及 coaching。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "師友及教練服務",
        "image_alt": ""
      },
      "zh-Hans": {
        "badge": "",
        "title": "师友及教练服务",
        "description": "以科技及实体提供一对一或小组形式的 mentorship 及 coaching。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "师友及教练服务",
        "image_alt": ""
      },
      "en": {
        "badge": "",
        "title": "Mentorship & Coaching",
        "description": "One-on-one and small-group mentorship and coaching, delivered online and in person.",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "Mentorship & Coaching",
        "image_alt": ""
      }
    }
  },
  {
    "id": 7,
    "slug": "flash-cards",
    "category": "tool",
    "accent_gradient": "from-yada-brown to-yada-coffee",
    "icon": "lucide:layout-grid",
    "cta_link": "mailto:info@yada.hk",
    "badge": "",
    "title": "生涯與升學 Flash Cards",
    "description": "互動式學習卡，協助學生認識不同升學及職業路徑。",
    "features": [],
    "audience": "",
    "table_features": "",
    "short_title": "生涯與升學 Flash Cards",
    "image_media_id": null,
    "image_uuid": null,
    "image_alt": "",
    "image_width": null,
    "image_height": null,
    "is_featured": 0,
    "sort_order": 70,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "badge": "",
        "title": "生涯與升學 Flash Cards",
        "description": "互動式學習卡，協助學生認識不同升學及職業路徑。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "生涯與升學 Flash Cards",
        "image_alt": ""
      },
      "zh-Hans": {
        "badge": "",
        "title": "生涯与升学 Flash Cards",
        "description": "互动式学习卡，协助学生认识不同升学及职业路径。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "生涯与升学 Flash Cards",
        "image_alt": ""
      },
      "en": {
        "badge": "",
        "title": "Career & Further-Study Flash Cards",
        "description": "Interactive study cards that help students learn about different further-study and career pathways.",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "Career & Further-Study Flash Cards",
        "image_alt": ""
      }
    }
  },
  {
    "id": 8,
    "slug": "claw-machine",
    "category": "tool",
    "accent_gradient": "from-yada-coffee to-yada-olive",
    "icon": "lucide:gamepad-2",
    "cta_link": "mailto:info@yada.hk",
    "badge": "",
    "title": "夾公仔機",
    "description": "以趣味互動形式吸引學生參與生涯規劃教育活動。",
    "features": [],
    "audience": "",
    "table_features": "",
    "short_title": "夾公仔機",
    "image_media_id": null,
    "image_uuid": null,
    "image_alt": "",
    "image_width": null,
    "image_height": null,
    "is_featured": 0,
    "sort_order": 80,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "badge": "",
        "title": "夾公仔機",
        "description": "以趣味互動形式吸引學生參與生涯規劃教育活動。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "夾公仔機",
        "image_alt": ""
      },
      "zh-Hans": {
        "badge": "",
        "title": "夹公仔机",
        "description": "以趣味互动形式吸引学生参与生涯规划教育活动。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "夹公仔机",
        "image_alt": ""
      },
      "en": {
        "badge": "",
        "title": "Claw Machine",
        "description": "A fun, interactive claw machine that draws students into career planning education activities.",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "Claw Machine",
        "image_alt": ""
      }
    }
  },
  {
    "id": 9,
    "slug": "harbour",
    "category": "service",
    "accent_gradient": "from-yada-coffee via-yada-brown to-yada-olive",
    "icon": "lucide:anchor",
    "cta_link": "/products/harbour",
    "badge": "",
    "title": "My Harbour 我的海灣",
    "description": "一個讓學生被真正認識的安全之所。",
    "features": [],
    "audience": "",
    "table_features": "",
    "short_title": "My Harbour 我的海灣",
    "image_media_id": null,
    "image_uuid": null,
    "image_alt": "",
    "image_width": null,
    "image_height": null,
    "is_featured": 0,
    "sort_order": 90,
    "published_at": 1791517272239,
    "locales": {
      "zh-Hant": {
        "badge": "",
        "title": "My Harbour 我的海灣",
        "description": "一個讓學生被真正認識的安全之所。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "My Harbour 我的海灣",
        "image_alt": ""
      },
      "zh-Hans": {
        "badge": "",
        "title": "My Harbour 我的海湾",
        "description": "一个让学生被真正认识的安全之所。",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "My Harbour 我的海湾",
        "image_alt": ""
      },
      "en": {
        "badge": "",
        "title": "My Harbour 我的海灣",
        "description": "A safe place to be known.",
        "features": [],
        "audience": "",
        "table_features": "",
        "short_title": "My Harbour 我的海灣",
        "image_alt": ""
      }
    }
  }
]
